// 获取六位随机数
export function getSixMathRandom() {
    let result = ''
    for(var i=0;i<6;i++){
        result += Math.floor(Math.random()*10);
    }
    return result
}
